module.exports = __webpack_public_path__ + "static/media/gift.bb43e57d.png";